interface ReviewsBlockProps {
  productId: number;
  rating: number;
  count: number;
}

const REVIEW_TEMPLATES = [
  {
    name: "Sofia M.",
    avatar: "S",
    color: "bg-accent-200 text-accent-900",
    text: "Melhor ainda ao vivo. Só a embalagem já me fez sorrir.",
    daysAgo: 4,
  },
  {
    name: "Daniel R.",
    avatar: "D",
    color: "bg-secondary-200 text-secondary-900",
    text: "Comprei de presente para minha parceira — ela amou. Vou comprar de novo.",
    daysAgo: 11,
  },
  {
    name: "Helena W.",
    avatar: "H",
    color: "bg-primary-200 text-primary-900",
    text: "Valeu a espera. A qualidade é linda e o artesão foi muito atencioso.",
    daysAgo: 23,
    rating: 4,
  },
];

export default function ReviewsBlock({ productId, rating, count }: ReviewsBlockProps) {
  return (
    <section className="w-full bg-background-100/60 border-y border-background-200/70">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8 py-12 md:py-16">
        {/* Header */}
        <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
          <div>
            <h2 className="font-heading text-foreground-950 text-3xl md:text-4xl">
              Avaliações
            </h2>
            <div className="mt-2 flex items-center gap-2 text-[13.5px] text-foreground-700">
              <span className="flex items-center gap-0.5 text-foreground-950">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`${i < Math.round(rating) ? "ri-star-fill" : "ri-star-line"} text-[16px]`}
                  ></i>
                ))}
              </span>
              <span className="font-medium text-foreground-950">{rating.toFixed(1)}</span>
              <span className="text-foreground-500">· {count} avaliações</span>
            </div>
          </div>
          <button
            type="button"
            className="inline-flex items-center gap-2 px-4 py-2.5 rounded-full border border-foreground-900 hover:bg-foreground-950 hover:text-background-50 text-foreground-900 text-[13px] font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-pencil-line"></i>
            Escrever uma avaliação
          </button>
        </div>

        {/* Reviews grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {REVIEW_TEMPLATES.map((rev, idx) => {
            const stars = rev.rating ?? 5;
            return (
              <article
                key={idx}
                className="bg-background-50 rounded-xl p-5 border border-background-200/70"
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className={`w-9 h-9 rounded-full ${rev.color} flex items-center justify-center text-sm font-semibold`}>
                    {rev.avatar}
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-[13.5px] font-medium text-foreground-950 truncate">{rev.name}</p>
                    <div className="flex items-center gap-1.5 mt-0.5">
                      <span className="flex items-center gap-0.5 text-foreground-950">
                        {Array.from({ length: 5 }).map((_, i) => (
                          <i
                            key={i}
                            className={`${i < stars ? "ri-star-fill" : "ri-star-line"} text-[11.5px]`}
                          ></i>
                        ))}
                      </span>
                      <span className="text-[11.5px] text-foreground-500">há {rev.daysAgo} dias</span>
                    </div>
                  </div>
                </div>
                <p className="text-[13.5px] leading-6 text-foreground-800">
                  {rev.text}
                </p>
              </article>
            );
          })}
        </div>

        <div className="text-center mt-8">
          <button
            type="button"
            className="text-[13.5px] text-foreground-800 hover:text-primary-600 underline underline-offset-4 cursor-pointer"
            data-product-id={productId}
          >
            Ler todas as {count} avaliações
          </button>
        </div>
      </div>
    </section>
  );
}